// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { UITabModel, UIFieldSetModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-tab',
  template: `
  <span *ngIf="workItem$ && tabId" [ngSwitch]="style.current()">
    <e5core-ui-work-tab-box *ngSwitchCase='0' [workItem$]='workItem$' [tab]='tab' [fieldSetIds]='fieldSetIds' ></e5core-ui-work-tab-box>
    <e5core-ui-work-tab-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [tab]='tab' [fieldSetIds]='fieldSetIds' ></e5core-ui-work-tab-bootstrap>
    <e5core-ui-work-tab-material *ngSwitchCase='2' [workItem$]='workItem$' [tab]='tab' [fieldSetIds]='fieldSetIds' ></e5core-ui-work-tab-material>
  </span>
  <div *ngIf="!(workItem$ && tabId)" class="e5core-component-error">&lt;e5core-ui-work-tab&gt; [tabId] must be > 0 and [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkTabComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() tabId: number ;

  workItemModel: WorkItemModel ;
  tab: UITabModel;
  fieldSetIds: number[] ;

  constructor(public style:UiStyleService, private cd: ChangeDetectorRef ) { }

  private updateTabModel(tabId: number) {
    this.tab = null ;
    this.fieldSetIds = [] ;
    if (this.workItemModel && this.workItemModel.tabs && this.workItemModel.tabs) {
      const tab = this.workItemModel.tabs.find(t => t.tabId == this.tabId) ;
      if (tab) {
        this.tab = tab ;
        this.fieldSetIds = tab.fieldSetIds ;
      } else {
        console.warn(`tabId ${this.tabId} is not in parent e5core-ui-work-tab-set`) ;
      }
    }
   }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-tab [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    if (this.tabId == null) {
      console.error('e5core-ui-work-tab [tabId] must have a number value');
      return ;
    }
    this.workItem$.subscribe(
      wi => {
        this.workItemModel = wi ;
        this.updateTabModel(this.tabId) ;
        this.cd.markForCheck();
      }
    );
  }

}
